var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "18px",
    viewBox: "0 0 9 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-627.000000, -1364.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "ruler"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.875,1364 C635.496208,1364 636,1364.50379 636,1365.125 L636,1380.875 C636,1381.49621 635.496208,1382 634.875,1382 L628.125,1382 C627.503792,1382 627,1381.49621 627,1380.875 L627,1365.125 C627,1364.50379 627.503792,1364 628.125,1364 L634.875,1364 Z M628.6875,1380.3125 L634.3125,1380.3125 L634.3125,1378.625 L632.34375,1378.625 C632.188362,1378.625 632.0625,1378.49914 632.0625,1378.34375 L632.0625,1377.78125 C632.0625,1377.62586 632.188362,1377.5 632.34375,1377.5 L634.3125,1377.5 L634.3125,1375.25 L632.34375,1375.25 C632.188362,1375.25 632.0625,1375.12414 632.0625,1374.96875 L632.0625,1374.40625 C632.0625,1374.25086 632.188362,1374.125 632.34375,1374.125 L634.3125,1374.125 L634.3125,1371.875 L632.34375,1371.875 C632.188362,1371.875 632.0625,1371.74914 632.0625,1371.59375 L632.0625,1371.03125 C632.0625,1370.87586 632.188362,1370.75 632.34375,1370.75 L634.3125,1370.75 L634.3125,1368.5 L632.34375,1368.5 C632.188362,1368.5 632.0625,1368.37414 632.0625,1368.21875 L632.0625,1367.65625 C632.0625,1367.50086 632.188362,1367.375 632.34375,1367.375 L634.3125,1367.375 L634.3125,1365.6875 L628.6875,1365.6875 L628.6875,1380.3125 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.93295e73.svg";
export { ForwardRef as ReactComponent };